export const register = (editor: any) => {
  editor.addButton('characterStyleSplit', {
    type: 'listbox',
    text: '',
    tooltip: 'Character Style',
    icon: 'characterStyle',
    menu: [
      {
        value: 'bold',
        icon: 'bold',
        text: 'Bold',
        onclick() {
          editor.execCommand('Bold');
        },
      },
      {
        value: 'italic',
        icon: 'italic',
        text: 'Italic',
        onclick() {
          editor.execCommand('Italic');
        },
      },
      {
        value: 'underline',
        icon: 'underline',
        text: 'Underline',
        onclick() {
          editor.execCommand('Underline');
        },
      },
      {
        value: 'strikethrough',
        icon: 'strikethrough',
        text: 'Strike Through',
        onclick() {
          editor.execCommand('Strikethrough');
        },
      },
    ],
    onselect() {
      this.value('');
    },
  });
};
